import { ChevronRightOutlineIcon } from '@ikyucom/design-system-icons-react'
// eslint-disable-next-line no-restricted-imports
import { useLocation } from '@remix-run/react'
import { ScrollableRestaurants } from '~/components/ScrollableRestaurants'
import type { FragmentType } from '~/lib/graphql'
import { getFragmentData, graphql } from '~/lib/graphql'
import type { RestaurantAreaFragment } from '~/lib/graphql/graphql'
import type { RestaurantId } from '~/lib/graphql/scalars'
import { recommendCardLinkPath } from '~/lib/path/path'
import { useIsPC } from '~/lib/ua'
import { css } from '~/styled-system/css'
import { hstack } from '~/styled-system/patterns'
import { GuideSection } from '../GuideSection'
import { BottomRestaurants } from '../pc/BottomRestaurants'

const RestaurantNearbyRestaurants = graphql(/* GraphQL */ `
  fragment RestaurantNearbyRestaurants on Restaurant {
    nearbyRestaurants(first: 5) {
      ...RestaurantRecommendCard
    }
  }
`)

type Props = {
  area: RestaurantAreaFragment
  restaurant: FragmentType<typeof RestaurantNearbyRestaurants>
  isLinkedToList?: boolean
}

export const NearbyRestaurants: React.FC<Props> = ({
  area,
  restaurant,
  isLinkedToList = false,
}) => {
  const data = getFragmentData(RestaurantNearbyRestaurants, restaurant)
  const { search } = useLocation()
  const linkTo = (restaurantId: RestaurantId) => recommendCardLinkPath(restaurantId, search)
  const isPc = useIsPC()
  const Restaurants = isPc ? BottomRestaurants : ScrollableRestaurants

  if (data.nearbyRestaurants.length === 0) {
    return null
  }

  return (
    // FIXME: 上位のコンポーネントでpaddingを設定するべき
    //        <https://github.com/ikyucom/macaron-frontend/issues/4517>
    <div className={css({ py: '3', _pc: { py: '0' } })}>
      <GuideSection
        heading={<Heading isLinkedToList={isLinkedToList} area={area.area} />}
        size="medium"
      >
        <Restaurants restaurants={data.nearbyRestaurants} linkTo={linkTo} />
      </GuideSection>
    </div>
  )
}

function Heading({
  isLinkedToList,
  area,
}: { isLinkedToList: boolean; area: RestaurantAreaFragment['area'] }) {
  const headingText = `${area.smallName}周辺の人気レストラン`
  return isLinkedToList ? (
    <a
      href={`/area/${area.mediumKey}/${area.smallCode}`}
      className={hstack({ gap: '2', alignItems: 'center' })}
    >
      {headingText}
      <ChevronRightOutlineIcon className={css({ color: 'primary' })} />
    </a>
  ) : (
    headingText
  )
}
